import { render, staticRenderFns } from "./IconPlus.vue?vue&type=template&id=f3eba8c6"
import script from "./IconPlus.vue?vue&type=script&lang=js"
export * from "./IconPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports